/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditDto } from '../../models/backend-credit-dto';
import { BackendCreditRequestDto } from '../../models/backend-credit-request-dto';

export interface FinancingSourcesCreditsCreate$FormData$Params {
  body: BackendCreditRequestDto;
}

export function financingSourcesCreditsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditDto>;
    }),
  );
}

financingSourcesCreditsCreate$FormData.PATH = '/api/financing_sources/credits/';
